define('v3/Common/Bindings/Numeric.Binding',[
	'knockout',
	'jquery',
	'jquery-numeric'
], function (ko, $) {
	ko.bindingHandlers.numeric = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var defaultOptions = {
				negative: false,
				decimal: false
			};

			// initialize control with some optional options
			var options = ko.utils.extend(defaultOptions, allBindingsAccessor().numericOptions);
			$(element).numeric(options);

			var underlyingObservable = valueAccessor();

			var interceptor = ko.computed({
				read: function () {
					var current = underlyingObservable();

					if (current == null) {
						return '';
					}

					return options.decimal
						? current.toString().replace(/\./g, options.decimal)
						: current.toString();
				},

				write: function (newValue) {
					var current = underlyingObservable();
					var valueToWrite = null;

					if (newValue !== null && newValue !== '') {
						if (options.decimal) {
							valueToWrite = parseFloat(newValue.replace(options.decimal, '.'));
						} else {
							valueToWrite = parseInt(newValue);
						}
					}

					if (valueToWrite !== current) {
						underlyingObservable(valueToWrite);
					}
				}
			});

			ko.applyBindingsToNode(element, { textInput: interceptor });
			if (ko.bindingHandlers.validationCore) {
				ko.bindingHandlers.validationCore.init(element, valueAccessor, allBindingsAccessor);
			}
		}
	};
});
